/** This file is auto-generated. Do not modify directly. */
import React from 'react';
import extendIcon from '../../extendIcon';

const Battery1 = props => (
  <svg viewBox="0 0 34 13" width="1em" height="1em" {...props}>
    <path d="M10.015 2.875h2.969v7h-2.969zM29.734 3.969H32v5.046h-2.266zM8.682 11h20.823v2H8.682z" />
    <path d="M7 0h1.849v13.016H7z" />
    <path d="M8.6 0h20.697v1.906H8.6z" />
    <path d="M29.088.016h1.563V13h-1.563z" />
  </svg>
);

export default extendIcon(Battery1);
